/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import React from "react";
import { useGetExportTemplateMutation } from "../../store/api/tasks/taskApiSlice";
import { errorMessage, exportInXML } from "../../utils/helpers";
import { useDispatch, useSelector } from "react-redux";
import { setOpenToast } from "../../store/helpers/helperReducers";
import { selectProfilePermissionsSelector } from "../../store/api/auth/selectors";
import ProfilePermissions from "../../utils/ProfilePermissions";
import { Button } from "../../components/ui/button";
import { Icon } from "../../components/Shared/Icon";

interface ITemplatesProps {
  selectedRow: { templateName?: string } | null;
}

const ExportTemplate: React.FC<ITemplatesProps> = ({ selectedRow = null }) => {
  const [getExportTempData] = useGetExportTemplateMutation();
  const dispatch = useDispatch();
  const permissions: ProfilePermissions | null = useSelector(selectProfilePermissionsSelector);

  const exportHandler = async (args: any) => {
    let response: any;
    try {
      response = await getExportTempData(args);
      if (response?.error?.originalStatus !== 200) throw response?.error;
      const encodedFileName = selectedRow?.templateName?.replace(/&amp;/g, '&') || selectedRow?.templateName;
      exportInXML(response, encodedFileName);
      dispatch(setOpenToast({ openToast: true, toastType: "success", message: "File dowloaded was Successfully Completed" }));
    } catch (error: any) {
      dispatch(setOpenToast({ openToast: true, toastType: "error", message: errorMessage(error) }));
    }
  };
  const addExportTemplate = () => {
    const encodedUri = encodeURIComponent(selectedRow?.templateName || "") || "";
    const decodedHtmlEntitiesPayload = encodedUri.replace(/%26amp%3B/g, '%26');
    if (selectedRow) {
      let args = { template: decodedHtmlEntitiesPayload };
      exportHandler(args);
    }
  };

  return (
    permissions?.hasOpCodeGroup("manage_topology") && (
      <div className="flex items-center">
                  <Button variant="ghost" size="icon" className="h-8 w-8 shrink-0 bg-transparent text-foreground hover:bg-accent hover:text-foreground" aria-label="Delete"   onClick={() => addExportTemplate()}>
                    <Icon name="download" size={18} />
                  </Button>
              </div>
    )
  );
};

export default ExportTemplate;
